import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { IVehiclesState } from './store/vehicles.state';
import { Observable } from 'rxjs';
import { setVehiclesAction } from './store/vehicles.actions';
import { getVehiclesSelectors } from './store/vehicles.selectors';
import {
  IIndividualsVehicles,
  IVehicles,
} from 'src/app/modules/interfaces/vehicles.interface';
import { VehiclesService } from 'src/app/services/vehicles.service';
import { getCookie } from 'src/app/utils/get-cookie';

@Component({
  selector: 'app-vehicles-form-collect',
  templateUrl: './vehicles.component.html',
  styleUrls: ['./vehicles.component.scss'],
})
export class VehiclesComponent implements OnInit {
  @Output() formSaved = new EventEmitter<void>();
  formsId: number;
  vehiclesData: IVehicles = {
    id: 0,
    has_vehicles: null,
    individuals_vehicles: [],
  };

  individualsVehiclesLocal: IIndividualsVehicles[];
  
  isLoading = true;
  isSaving = false;
  saveButtonText = 'Salvar';
  saveButtonClass = 'btn-primary';

  dataState$: Observable<IVehiclesState>;
  dataState: IVehiclesState = {
    check: true,
    vehicles: undefined,
    listVehicles: [],
  };
  listLocal: Array<any> = [];

  constructor(
    private store: Store,
    private vehiclesService: VehiclesService
  ) {
    this.formsId = Number(getCookie('formsId'));
  }

  async ngOnInit() {
    await this.getState();
    this.loadVehiclesData()

    this.listLocal = [...this.dataState.listVehicles];

    if (this.listLocal.length === 0) {
      await this.addList();
    }
  }

  loadVehiclesData(): void {
    this.isLoading = true;
    this.vehiclesService.getVehiclesData(this.formsId).subscribe((response)=> {
      if (response) {
        this.vehiclesData = {
          id: response.id,
          has_vehicles: response.has_vehicles,
          individuals_vehicles: response.individuals_vehicles
        },
        this.individualsVehiclesLocal = response.individuals_vehicles
        this.saveState()
      }
    })
  }

  updateIndividualList(data, index): void {
    if (this.isValidIndex(index)) {
      const updatedVehicles = [...this.vehiclesData.individuals_vehicles];
      updatedVehicles[index] = { ...data };
  
      this.vehiclesData.individuals_vehicles = updatedVehicles;
      (this.vehiclesData)
      // this.setState(this.dataState);
    }
  }

  saveForm(): void {
    this.isSaving = true;
    this.saveButtonText = 'Salvando...';
    this.saveButtonClass = 'btn-secondary';
  
    
    this.vehiclesService.updateVehiclesData(this.formsId, this.vehiclesData.id, this.vehiclesData).subscribe({
      next: () => {
        this.isSaving = false;
        this.saveButtonText = 'Salvo';
        this.saveButtonClass = 'btn-primary';
        this.saveState()
        this.formSaved.emit();
      },
      error: (err) => {
        this.isSaving = false;
        this.saveButtonText = 'Erro ao salvar';
        this.saveButtonClass = 'btn-danger';
        console.error('Erro ao atualizar os dados de Veículos', err);
      },
    });
  }
  
  saveState(): void {
    const formattedListVehicles = this.individualsVehiclesLocal.map((vehicle) => ({
      check: true,
      model: vehicle.description || '',
      yearOfPurchase: vehicle.purchased_year || 0,
      estimatedValue: Number(vehicle.vehicles_value) || 0,
    }));
  
    this.dataState = {
      ...this.dataState,
      check: this.individualsVehiclesLocal.length > 0,
      vehicles: this.vehiclesData.has_vehicles === 1,
      listVehicles: formattedListVehicles,
    };
  
    this.setState(this.dataState);
  }
  
  onFieldChange(): void {
    if (!this.isSaving) {
      this.saveButtonText = 'Salvar';
      this.saveButtonClass = 'btn-primary';
    }
  }

  isValidIndex(index: number): boolean {
    return index >= 0 && index < this.individualsVehiclesLocal.length;
  }

  addList(): void {
    if (!Array.isArray(this.individualsVehiclesLocal)) {
      this.individualsVehiclesLocal = [];
    }

    const newVehicle: IIndividualsVehicles = {
      vehicles_id: this.vehiclesData.id,
      description: '',
      purchased_year: 2025,
      vehicles_value: 0,
    };

    this.individualsVehiclesLocal = [...this.vehiclesData.individuals_vehicles, newVehicle];
    this.vehiclesData.individuals_vehicles = [
      ...this.vehiclesData.individuals_vehicles,
      newVehicle,
    ];
  }

  setState(data: IVehiclesState): void {
    this.store.dispatch(setVehiclesAction(data));
    this.isLoading = false;

  }

  getState() {
    this.dataState$ = this.store.select(getVehiclesSelectors);

    this.dataState$.subscribe((value) => {
      this.dataState = {
        ...(this.dataState = value),
      };
    });
  }

  setValuesForm(): void {
    this.dataState.check = !!this.dataState.vehicles;
    this.setState(this.dataState);
  }

  updateList(data, index): void {
    if (this.isValidIndex(index)) {
      const updatedVehicles = [...this.dataState.listVehicles];
      updatedVehicles[index] = { ...data };

      this.dataState.listVehicles = updatedVehicles;
      this.setState(this.dataState);
    }
  }

  deleteList(index: number): void {
    if (this.isValidIndex(index)) {
    
      this.individualsVehiclesLocal.splice(index, 1);
      this.vehiclesData.individuals_vehicles.splice(index, 1);
  
      
      this.dataState.listVehicles = this.individualsVehiclesLocal.map((vehicle) => ({
        check: true,
        model: vehicle.description || '',
        yearOfPurchase: vehicle.purchased_year || 0,
        estimatedValue: Number(vehicle.vehicles_value) || 0,
      }));
  
      
      this.setState(this.dataState);
    }
  }
  
  
}
